
import {templateParts} from "@benev/slate/x/tools/templating.js"

export const icon = templateParts

